import { Component, OnInit } from '@angular/core';
import { EpbtFaCompetitorService } from '../../services/epbt-fa-competitor.service';
import { ProductCompetitorPrice, ProductCompetitor, Per, CompetitorPricingLine, FieldAgentClient } from 'ep-bt-field-agent-proxy';
import { EpButtonStyle } from '@epicor/kinetic';
import { Router } from '@angular/router';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-competitor-summary',
  templateUrl: './epbt-fa-competitor-summary.component.html',
  styleUrls: ['./epbt-fa-competitor-summary.component.scss']
})
export class EpbtFaCompetitorSummaryComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;
  request: CompetitorPricingLine[] = [];
  priceType: any;
  constructor(private epbtFaCompetitorService: EpbtFaCompetitorService, private client: FieldAgentClient, private router: Router) { }

  ngOnInit() {
  }

  completeCompetitor() {

    this.epbtFaCompetitorService.competitorPricing.Lines.forEach(item => {

      const competitorPricingLine = new CompetitorPricingLine();

      competitorPricingLine.productID = item.ourProduct.productId;
      competitorPricingLine.competitorID = item.competitorID;
      competitorPricingLine.sellPrice = item.competitorSellPrice;
      competitorPricingLine.sellPerID = item.competitorSellPerID;
      competitorPricingLine.sellPer = item.competitorSellPer;
      competitorPricingLine.dateTimeLastUpdated = new Date();
      competitorPricingLine.notes = item.notes;
      if (this.epbtFaCompetitorService.competitorPricing.SelectedAddress) {
        competitorPricingLine.addressID = this.epbtFaCompetitorService.competitorPricing.SelectedAddress.addressId;
      }
      competitorPricingLine.productCode = item.productCode;
      competitorPricingLine.productDescription = item.productDescription;
      this.request.push(competitorPricingLine);
    });

    this.priceType = this.epbtFaCompetitorService.competitorPricing.PriceType;
    this.client.addOrUpdateProductCompetitors(this.request, this.priceType).subscribe(res => {
      // console.log(res);
      this.router.navigate(['/home']);
      this.epbtFaCompetitorService.clearData();
    });


  }


}
